/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, Suspense } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import moment from "moment";
import { Divider, Row, Input, Col, Form, Upload, Menu, Tabs, Spin } from "antd";
import Button from "@ui/form-controls/button";
import Icon, { PaperClipOutlined } from "@ant-design/icons";

import FileImage from "@assets/images/svg/fileimage.png";
import {
  getReminderLists,
  deleteReminder,
  addMultipleDocuments,
  clearDownloadDocument,
  clearDeleteDocument,
  downloadDocument,
  deleteDocument,
  multipleDocsClear
} from "@redux/actionCreators";
import Loader from "@ui/feedback/loader";
import { ReactComponent as Delete } from "@assets/images/svg/deleteClose.svg";

import "./reminders.scss";

const detailsMenu = [{ name: "Content" }, { name: "Attachment" }];
const { Dragger } = Upload;
const { TextArea } = Input;
const { SubMenu } = Menu;
const { TabPane } = Tabs;

const returnParamsData = filesListData => {
  let tempList = [];
  if (filesListData.length !== 0) {
    tempList = filesListData.map(data => {
      return {
        Key: "ATTACHMENT",
        Name: data.name,
        MimeType: "unknown"
      };
    });
  }
  return tempList;
};

// submenu keys of first level
const rootSubmenuKeys = ["sub1"];

const Reminders = () => {
  const formRef = useRef();
  const dispatch = useDispatch();

  const [notesFileArray, setNotesFileArray] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [openKeys, setOpenKeys] = useState(["sub1"]);
  const [disableFlag, setFlag] = useState(true);

  const reducerDriverData = useSelector(state => state.driverReducer || null, shallowEqual);

  const notesProps = {
    name: "file",
    multiple: true,
    action: "",
    fileList: notesFileArray,
    showUploadList: { showDownloadIcon: true },
    customRequest: () => "",
    beforeUpload: file => {
      setFileArrayFn(file);
    },
    onRemove: file => {
      removeFileArrayFn(file);
    },
    onDownload: file => {
      downloadFileArrayFn(file);
    }
  };

  const {
    remindersList: { resultData, isLoading },
    deleteReminderInfo,
    addMultipleDocumentsList,
    downloadDocumentInfo
  } = reducerDriverData;

  const reminders = resultData?.Data?.NoteReminderArgs || [];

  const onOpenChange = keys => {
    const latestOpenKey = keys.find(key => openKeys.indexOf(key) === -1);
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  const setFileArrayFn = file => {
    setNotesFileArray(previousFiles => [...previousFiles, file]);
  };

  const removeFileArrayFn = file => {
    if (file?.objectId) {
      dispatch(deleteDocument([file?.objectId]));
    }
    const filteredFiles = notesFileArray.filter(item => file.name !== item.name);
    setNotesFileArray([...filteredFiles]);
  };

  const saveData = () => {
    const notesFiles = [...notesFileArray].filter(data => !data.objectId);
    const formData = new FormData();
    if (notesFiles.length !== 0) {
      notesFiles.forEach(file => {
        if (!file.objectId) {
          formData.append("files", file);
        }
      });
    }
    const paramsData = returnParamsData(notesFiles).map(item => {
      // eslint-disable-next-line no-param-reassign
      item.TargetObjectId = selectedItem?.Note?.ObjectId;
      return item;
    });
    if (notesFiles.length !== 0) {
      dispatch(
        addMultipleDocuments({
          payload: formData,
          params: JSON.stringify(paramsData)
        })
      );
    }
  };

  const downloadFileArrayFn = file => {
    const payload = {
      documentObjectId: file?.objectId,
      documentName: file?.name
    };
    setSelectedDoc(file);
    dispatch(downloadDocument(payload));
  };

  const downloadFile = (file, fileName) => {
    const href = URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = href;
    link.setAttribute("download", fileName || "attachment.png");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const selectedMenuItem = event => {
    setSelectedItem(event);
    setFlag(false);
    formRef.current?.setFieldsValue({
      content: event?.Note?.MetaData?.MetaEntry?.content || ""
    });
    const files = (event?.Note?.Files || []).map(item => {
      return {
        uid: item.ObjectId,
        name: item.Name,
        objectId: item.ObjectId,
        status: "done"
      };
    });
    setNotesFileArray(files);
  };

  const deleteReminderList = data => {
    dispatch(deleteReminder(data.ObjectId));
  };

  useEffect(() => {
    dispatch(getReminderLists(moment().format("YYYY-MM-DDTHH:mm:ss")));
    return () => {
      dispatch(clearDownloadDocument());
      dispatch(clearDeleteDocument());
      dispatch(multipleDocsClear());
      setNotesFileArray([]);
      setSelectedDoc(null);
      setSelectedItem(null);
    };
  }, []);

  useEffect(() => {
    if (deleteReminderInfo.resultData) {
      dispatch(getReminderLists(moment().format("YYYY-MM-DDTHH:mm:ss")));
      setSelectedItem(null);
      formRef.current?.setFieldsValue({
        content: ""
      });
    }
  }, [deleteReminderInfo.resultData]);

  useEffect(() => {
    if (downloadDocumentInfo.resultData) {
      downloadFile(downloadDocumentInfo.resultData, selectedDoc?.name);
      setSelectedDoc(null);
      dispatch(getReminderLists(moment().format("YYYY-MM-DDTHH:mm:ss")));
    }
  }, [downloadDocumentInfo.resultData]);

  useEffect(() => {
    if (addMultipleDocumentsList.resultData) {
      dispatch(getReminderLists(moment().format("YYYY-MM-DDTHH:mm:ss")));
    }
  }, [addMultipleDocumentsList]);

  useEffect(() => {
    if (resultData) {
      dispatch(clearDownloadDocument());
      dispatch(clearDeleteDocument());
      dispatch(multipleDocsClear());
      setNotesFileArray([]);
      setSelectedDoc(null);
      setSelectedItem(null);
      formRef.current?.setFieldsValue({
        content: ""
      });
    }
  }, [resultData]);

  return (
    <div>
      <>
        <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 32 }]} className="tasks-form">
          <Col span={8}>
            <Spin
              indicator={<Loader />}
              spinning={isLoading || addMultipleDocumentsList.isLoading}
              className="loaderGifPosition"
            >
              <Menu
                mode="inline"
                openKeys={openKeys}
                onOpenChange={onOpenChange}
                style={{ background: "#F1F1F1", height: "400px", overflow: "scroll" }}
              >
                <SubMenu key="sub1" title="New Reminders">
                  {reminders &&
                    reminders.map(data => (
                      <Menu.Item
                        value={data.ObjectId}
                        key={data.ObjectId}
                        onClick={() => selectedMenuItem(data)}
                      >
                        {moment(data.ReminderDate).format("DD-MM-YYYY HH:mm")}
                        <Icon
                          component={Delete}
                          className="icon-behaviour delete-icon rem-del"
                          onClick={() => deleteReminderList(data)}
                        />
                      </Menu.Item>
                    ))}
                  {reminders.length === 0 && (
                    <Menu.Item value={null} key="noData">
                      No Reminders added yet
                    </Menu.Item>
                  )}
                </SubMenu>
              </Menu>
            </Spin>
          </Col>
          <Col span={16}>
            <Form
              name="dynamic_form_nest_holidays_details"
              autoComplete="off"
              className=""
              ref={formRef}
            >
              <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 32 }]}>
                <div style={{ marginTop: "" }}>
                  <span className="sections">Linked To: </span> {selectedItem?.Target?.Name || ""}
                </div>
              </Row>

              <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 32 }]}>
                <div style={{ marginTop: "1rem" }}>
                  <span className="sections">Notes Title:</span> {selectedItem?.Note?.Name || ""}
                </div>
              </Row>

              <Tabs defaultActiveKey="Content" className="details-all-tabs">
                {[...detailsMenu].map(({ name }) => (
                  <TabPane tab={`${name}`} key={name}>
                    <Suspense fallback={<Loader />}>
                      {name === "Content" && (
                        <div className="">
                          <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 32 }]}>
                            <Col span={22}>
                              <Form.Item
                                labelCol={{ span: 24 }}
                                label=""
                                name="content"
                                fieldKey="content"
                                rules={[{ required: true, message: "Missing content" }]}
                              >
                                <TextArea rows={4} disabled />
                              </Form.Item>
                            </Col>
                          </Row>
                        </div>
                      )}

                      {name === "Attachment" && (
                        <div className="">
                          <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 32 }]}>
                            <Col span={22}>
                              <div className="attach-file-div">
                                <Row justify="start" align="middle">
                                  <span className="f-title">Attach Document</span>
                                </Row>
                                <Row className="draggerbox">
                                  <div className="file-details">
                                    <img src={FileImage} alt="FileImage" />
                                  </div>
                                  <Divider type="vertical" className="divider" />
                                  <Form.Item
                                    labelCol={{ span: 24 }}
                                    name="notesFile"
                                    fieldKey="notesFile"
                                    rules={[{ required: false, message: "Missing Document" }]}
                                  >
                                    <Dragger {...notesProps}>
                                      <PaperClipOutlined className="clip-icon" />
                                      <a className="addFile">Add File </a>
                                      <p className="draggertitle">or Drop files here</p>
                                      <p className="fileType">
                                        Only .PDF, .JPEG, .JPG and .PNG files allowed to upload
                                      </p>
                                    </Dragger>
                                  </Form.Item>
                                </Row>
                              </div>
                            </Col>
                          </Row>

                          <Row className="steps-action stepper-btn-section" justify="end">
                            <Button
                              variant="primary"
                              htmlType="submit"
                              onClick={() => saveData()}
                              disabled={disableFlag}
                            >
                              Save
                            </Button>
                          </Row>
                        </div>
                      )}
                    </Suspense>
                  </TabPane>
                ))}
              </Tabs>
            </Form>
          </Col>
        </Row>
      </>
    </div>
  );
};

export default Reminders;